import React, { useState } from "react";
import Markdown from "react-markdown";
import { ImageProvider } from "../../../utils/image-provider";

const Faqs = ({ data, tabname }) => {
  const {
    heading,
    heading_color,
    faq_bg_color,
    faq_section,
    arrow_1,
    arrow_2,
  } = data || [];

  const [openIdx, setOpenIdx] = useState(0);

  const toId = (text) =>
    text
      ?.toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const toggle = (index) => {
    setOpenIdx(openIdx === index ? null : index);
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity:
      faq_section?.map((faqItem) => ({
        "@type": "Question",
        name: faqItem?.heading?.data?.heading,
        acceptedAnswer: {
          "@type": "Answer",
          text: faqItem?.description?.data?.description,
        },
      })) || [],
  };

  return (
    <div id="FAQ's" className="w-full mb-4">

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema),
        }}
      />

      <section className="w-[90%] mx-auto xl:py-[2vw] py-[4vw] bg-white rounded-[1vw]">
        {/* Heading */}
        <div className="flex justify-center">
          <div className="inline-block text-center lg:border-b-[0.2vw] border-b-[0.6vw] border-[#E88334]">
            <h2 className="font-redhatBold text-[5.5vw] lg:text-[2.24vw] text-[#0D2E5E] leading-tight">
              {heading}
            </h2>
          </div>
        </div>

        {/* FAQ Boxes */}
        <div className="w-full mx-auto lg:mt-[3vw] mt-[6vw]">
          {faq_section?.map((faqItem, index) => {
            const question = faqItem.heading?.data?.heading;
            const qId = toId(question);
            const isExpanded = openIdx === index;

            return (
              <div
                key={index}
                className="lg:rounded-[1.5vw] rounded-[3vw] px-[4vw] xl:px-[1vw] bg-[#EDEDED] lg:mb-[1vw] mb-[3vw]"
              >
                <button
                  id={`${qId}-button`}
                  type="button"
                  className="w-full flex items-center justify-between py-[2vw] xl:py-[1vw]
                  focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
                  aria-expanded={isExpanded}
                  aria-controls={`${qId}-panel`}
                  onClick={() => toggle(index)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      toggle(index);
                    }
                  }}
                >
                  <h3 className="text-left font-redhatBold text-[#0D2E5E] lg:text-[1.2vw] text-[3.5vw] md:text-[2.5vw] lg:pl-8 pl-4 py-2">
                    {question}
                  </h3>

                  <span className="ml-2 flex-shrink-0" aria-hidden="true">
                    <ImageProvider
                      Image={isExpanded ? arrow_2 : arrow_1}
                      alt=""
                      tailwindStyle="w-[3vw] h-[3vw] xl:w-[1vw] xl:h-[1vw]"
                    />
                  </span>
                </button>

                {isExpanded && (
                  <div
                    id={`${qId}-panel`}
                    role="region"
                    aria-labelledby={`${qId}-button`}
                    className="markdown_list pb-[2vw] xl:pb-[1vw] lg:pl-[3vw] pl-[6vw] text-[#0D2E5E] font-redhatRegular lg:text-[1.2vw] md:text-[2.5vw] text-[3.5vw] [&_a]:text-blue-600"
                  >
                    <Markdown
                      components={{
                        p: ({ children }) => (
                          <div className="lg:mb-[1.042vw] mb-[3vw] leading-tight font-redhatRegular">
                            {children}
                          </div>
                        ),
                        a: ({ href, children, ...props }) => {
                          const isEmail = href?.startsWith("mailto:");
                          const isPhone = href?.startsWith("+91");

                          return (
                            <a
                              href={
                                isEmail
                                  ? `mailto:${href}`
                                  : isPhone
                                  ? `tel:${href}`
                                  : href
                              }
                              rel="noopener noreferrer"
                              className="underline text-blue-700 inline-flex items-center min-h-[24px] min-w-[24px] px-1 py-1"
                              {...props}
                            >
                              {children}
                            </a>
                          );
                        },
                      }}
                    >
                      {faqItem.description?.data?.description}
                    </Markdown>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Faqs;
